// NetworkCard.tsx
import React from 'react';
import useGlobalStore from "../stores/globalStore";

function NetworkCard({ data }) {
  //Stores
  const selectedNetwork = useGlobalStore((state) => state.selectedNetwork);
  const setSelectedNetwork = useGlobalStore((state) => state.setSelectedNetwork);

  //Functions
  const handleCardSelection = () => {
    setSelectedNetwork(data);
  };

  return (
    <div
      key={data.id}
      className={
        selectedNetwork.id === data.id
          ? `tel-pt-card selected tel-pt-${data.type}-card `
          : ` tel-pt-card tel-pt-${data.type}-card `
      }
      onClick={handleCardSelection}
    >
      <div className="tel-pt-card__content">
        {data.image && <div className="tel-pt-card__image" style={{ backgroundImage: `url(${data.image})` }}></div>}

        <div className="tel-pt-card__info">
          <h3 className="tel-pt-card__title">{data.title.replace(/&#038;/g, "&")}</h3>
          {data.description && (
            <p className="tel-pt-card__description" dangerouslySetInnerHTML={{ __html: data.description }} />
          )}
        </div>
      </div>
    </div>
  );
}

export default NetworkCard;